import React, { useEffect } from 'react';
import { Layout } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
	updateBidderStatus,
	requestsForProposalRestCrudThunksForSupplier,
} from '../../thunks/requests_for_proposal_thunks';
import { PageLoadingPlaceholder } from '../page_loading_placeholder/PageLoadingPlaceholder';
import { proposalsRestCrudThunksForSupplier } from '../../thunks/proposals_thunks';
import { clearNavbarState, updateNavbarState } from '../../actions/navbar_actions';
import { generateBackLink } from '../../utils/HistoryUtils';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import { workOrdersRestCrudThunksForSupplier } from '../../thunks/work_orders_thunks';
import BidderNotes from '../rfp_detail_bids_page/BidderNotes/BidderNotes';

const { Content } = Layout;

const BidderNotesSupplierPage = (props) => {
	const {
		updateNavbar,
		location,
		clearNavbar,
		requestForProposal,
		currentUser,
		requestsForProposalFetching,
		proposalsFetching,
	} = props;

	useEffect(() => {
		updateNavbar(
			'Back to RPFs',
			generateBackLink('/supplier/opportunities/overview/all', location)
		);

		return () => {
			clearNavbar();
		};
	}, [updateNavbar, location, clearNavbar]);

	const fetching = requestsForProposalFetching || proposalsFetching;

	return fetching || !requestForProposal.id ? (
		<PageLoadingPlaceholder />
	) : (
		<Content className="rfpDetailDetailsPage" style={{ padding: '0 0.5em' }}>
			<BidderNotes
				selectedBidder={{
					...requestForProposal,
					requestForProposalId: requestForProposal.id,
					supplierFacilityId: nullSafeGet('facility.id', currentUser),
				}}
			/>
		</Content>
	);
};

const mapStateToProps = (state, ownProps) => ({
	requestsForProposalFetching: state.requests_for_proposal.fetching,
	requestForProposal: state.requests_for_proposal.detail,
	proposals: state.proposals,
	proposalsFetching: state.proposals.fetching,
	currentUser: state.session.currentUser,
	match: ownProps.match,
	history: ownProps.history,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	updateStatus: (entity, status) => dispatch(updateBidderStatus(ownProps.userType)(entity, status)),
	getRequestForProposal: (id) => dispatch(requestsForProposalRestCrudThunksForSupplier.readOne(id)),
	getProposals: (params, targetCollection) =>
		dispatch(proposalsRestCrudThunksForSupplier.read(params, targetCollection)),
	updateNavbar: (backlinkTitle, backlinkTo, navbarBackgroundColor) =>
		dispatch(updateNavbarState(backlinkTitle, backlinkTo, navbarBackgroundColor)),
	clearNavbar: () => dispatch(clearNavbarState()),
	createWorkOrder: (entity) => dispatch(workOrdersRestCrudThunksForSupplier.create(entity)),
});

const ComponentWithoutUserType = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(BidderNotesSupplierPage)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
